import React from "react";
import styled from "styled-components";
import StyledButton from "./StyledButton";
import { get, getFocus, useGet } from "state/jotai";
import { _project } from "state/store.projects";
import PageHighlights from "./PageHighlights";
import { BREAK_ } from "constants";
import WebDescription from "./WebsiteDescription";
import { params_query } from "state/store.global";

const DescriptionSectionWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  background: ${({}) => `${f_clr.secondaryColor}`};
  padding: 80px 24px 24px 24px;
  box-sizing: border-box;
  gap: 40px;
  justify-content: center;
  align-items: center;
  border-radius : 0 0 16px  16px;
  ${BREAK_.md_dn} {
    flex-direction: column;
    align-items: center;
  }

  @media only screen and (max-width: 1024px) {
    padding: 24px;
  }

  @media only screen and (max-width: 600px) {
    padding: 24px 16px;
  }
`;

const Description = styled.div`
  display: flex;
  max-width: 800px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;

  ${BREAK_.md_dn} {
    width: 100%;
    gap: 24px;
    margin: 0;
  }
`;

const ImageContainer = styled.div`
  flex: 1;
  max-width: 700px;
  min-width: 394px;
  height: 420px;
  flex-shrink: 0;
  border-radius: 16px;
  background: ${({ background }) =>
    `url(${background}) lightgray 50% / cover no-repeat`};
  // margin-top: 60px;

  @media only screen and (max-width: 1080px) {
    margin-top: 0px;
  }
  @media only screen and (max-width: 1024px) {
    flex: none;
    margin-top: 0px;
    height: 236px;
  }
  @media only screen and (max-width: 600px) {
    display: none;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 0;
  ${BREAK_.md_dn} {
    margin-top: 16px;
  }
`;

const HeaderDescription2 = ({
  page,
  propertyDescriptionBackgroundFrontpage: pdbf,
  UnitDescriptionBackgroundFrontpage: udbf,
}) => {
  const params = useGet(params_query);
  const gallery = get(_project, "gallery");
  const listOfPhotos = gallery?.[0]?.Data?.ListOfPhotos || [];
  const availableImages = listOfPhotos.filter((photo) => photo?.Url);

  // ✅ Conditional image selection logic
  const UnitImage =
  page === "unitpage" ? udbf?.[0]?.ImageLink : pdbf?.[0]?.ImageLink;

  return (
    <DescriptionSectionWrapper>
      <Description>
        <WebDescription
          headerStyle={{ mb: "16px" }}
          header={page === "unitpage" ? udbf?.[0]?.Headline : pdbf?.[0]?.Headline1}
          content={page === "unitpage" ? udbf?.[0]?.Text : pdbf?.[0]?.Text1}
          overlayColor={`${f_clr.primaryColor}`}
          color={"#000"}
        />

        {page === "unitpage" ? (
          <PageHighlights udbf={udbf} />
        ) : (
          <WebDescription
            headerStyle={{ mb: "16px" }}
            header={pdbf?.[0]?.Headline2}
            content={pdbf?.[0]?.Text2}
            overlayColor={`${f_clr.primaryColor}`}
            color={"#000"}
          />
        )}

        <ButtonWrapper>
          <StyledButton
            Linkto={pdbf?.[0]?.CTAlink ? pdbf?.[0]?.CTAlink : "/isometry"}
            text={page === "unitpage" ? udbf?.[0]?.CTAlabel : pdbf?.[0]?.CTAlabel}
            showIcon
          />
        </ButtonWrapper>
      </Description>

      <ImageContainer background={UnitImage} />
    </DescriptionSectionWrapper>
  );
};

export default HeaderDescription2;
